import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";

import {
  Typography,
  Button,
  Paper,
  Box,
  Stack,
  Avatar,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";

import BadgeIcon from '@mui/icons-material/Badge';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MapIcon from '@mui/icons-material/Map';
import LogoutIcon from '@mui/icons-material/Logout';

export default function Dashboard() {
  const { admin, logout } = useContext(AuthContext);
  
  const [openLogoutConfirm, setOpenLogoutConfirm] = useState(false);

  const handleConfirmLogout = () => {
    setOpenLogoutConfirm(false);
    logout();
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#FFFDF8", py: 4, pb: 12 }}>
      <Container maxWidth="lg">
        
        <Typography 
          variant="h4" 
          fontWeight="900" 
          sx={{ mb: 4, color: '#3A2C23', textAlign: 'center' }}
        >
          Admin Dashboard
        </Typography>

        {/* 👤 PROFILE SECTION */}
        <Box sx={{ maxWidth: 600, mx: "auto", mb: 6 }}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 3, 
              mb: 4, 
              bgcolor: '#FFFFFF',
              borderRadius: '24px', 
              border: 'none', 
              boxShadow: '0 10px 24px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              '&:hover': {
                transform: 'translateY(-3px)',
                boxShadow: '0 16px 32px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1)',
              }
            }}
          >
            <Stack spacing={2.5}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: '#FFF6DE', color: '#F29D17', width: 48, height: 48 }}>
                  <BadgeIcon />
                </Avatar>
                <Box>
                  <Typography variant="caption" sx={{ color: '#A59D96', fontWeight: '800', letterSpacing: 0.5 }}>ROLE</Typography>
                  <Typography variant="h6" sx={{ color: '#2F2A25', fontWeight: '800', lineHeight: 1.1 }}>{admin?.role || 'N/A'}</Typography>
                </Box>
              </Box>

              <Divider sx={{ borderStyle: 'dashed', borderColor: '#ECE5DA' }} />

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: '#E1EED3', color: '#577A34', width: 48, height: 48 }}>
                  <LocationCityIcon />
                </Avatar>
                <Box>
                  <Typography variant="caption" sx={{ color: '#A59D96', fontWeight: '800', letterSpacing: 0.5 }}>CITY</Typography>
                  <Typography variant="h6" sx={{ color: '#2F2A25', fontWeight: '800', lineHeight: 1.1 }}>{admin?.city || 'N/A'}</Typography>
                </Box>
              </Box>

              <Divider sx={{ borderStyle: 'dashed', borderColor: '#ECE5DA' }} />

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: '#FEE2E2', color: '#DC2626', width: 48, height: 48 }}>
                  <MapIcon />
                </Avatar>
                <Box>
                  <Typography variant="caption" sx={{ color: '#A59D96', fontWeight: '800', letterSpacing: 0.5 }}>ZONE</Typography>
                  <Typography variant="h6" sx={{ color: '#2F2A25', fontWeight: '800', lineHeight: 1.1 }}>{admin?.zone || 'N/A'}</Typography>
                </Box>
              </Box>
            </Stack>
          </Paper>

          {/* Action Buttons */}
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button
              variant="contained"
              disableElevation
              startIcon={<LogoutIcon />}
              onClick={() => setOpenLogoutConfirm(true)}
              sx={{ 
                flex: 1, py: 1.5, borderRadius: '16px', bgcolor: '#FFF0EE', color: '#E85D3F',
                fontWeight: '900', textTransform: 'none', fontSize: '1.05rem',
                border: '1px solid #FFE4E0', '&:hover': { bgcolor: '#FFE4E0' }
              }}
            >
              Logout
            </Button>
          </Stack>
        </Box>
      </Container>

      {/* Logout Confirmation Dialog */}
      <Dialog open={openLogoutConfirm} onClose={() => setOpenLogoutConfirm(false)} PaperProps={{ sx: { borderRadius: '24px', p: 1, minWidth: '300px', textAlign: 'center', bgcolor: '#FFFDF8', boxShadow: '0 24px 48px rgba(0,0,0,0.15)' } }}>
        <DialogTitle sx={{ fontWeight: '900', color: '#3A2C23', pb: 1 }}>Log Out?</DialogTitle>
        <DialogContent sx={{ pb: 2 }}>
          <Typography variant="body2" color="#6E655E" fontWeight="600">Are you sure you want to log out of your admin account?</Typography>
        </DialogContent>
        <Stack direction="row" spacing={2} sx={{ px: 3, pb: 3 }}>
          <Button fullWidth variant="outlined" onClick={() => setOpenLogoutConfirm(false)} sx={{ borderRadius: '16px', color: '#6E655E', borderColor: '#858482', fontWeight: '800', textTransform: 'none', '&:hover': { borderColor: '#A59D96', bgcolor: '#FFF6DE' } }}>Cancel</Button>
          <Button fullWidth variant="contained" disableElevation onClick={handleConfirmLogout} sx={{ borderRadius: '16px', bgcolor: '#5a4e22', color: '#FFFFFF', fontWeight: '800', textTransform: 'none', '&:hover': { bgcolor: '#DC2626' } }}>Log out</Button>
        </Stack>
      </Dialog>
    </Box>
  );
}